import { getHomePath } from '@/src/routes/routes';
import { BagSVG, EmptyOrdersStateSVG, EmptyStateSVG, HeartOutlineSVG } from '@/src/ui/AllSVG';
import Link from 'next/link';
import React from 'react'

interface EmptyStateProps {
    title?: string;
    description?: string;
}

export default function EmptyState({
    title = 'No results found',
    description = "Try adjusting your filters or search to find what you're looking for.",
}: EmptyStateProps) {
    return (
        <>
            <div className="flex flex-col items-center justify-center py-24 gap-5 text-center">
                <div className="relative flex items-center justify-center">
                    <div className="relative z-10 w-20 h-20 p-5 rounded-full bg-muted-color flex items-center justify-center text-body-color">
                        <EmptyStateSVG />
                    </div>
                </div>
                <div className="space-y-2">
                    <h3 className="font-semibold text-xl text-heading-color tracking-tight">{title}</h3>
                    <p className="text-sm text-body-color/50 max-w-[260px] leading-relaxed">{description}</p>
                </div>
            </div>
        </>
    )
}

export function EmptyOrdersState({ title = 'No orders found', description = "You haven't placed any orders yet." }: EmptyStateProps) {
    return (
        <div className="dashboard_card flex flex-col items-center justify-center py-16 gap-3 text-center">
            <EmptyOrdersStateSVG />
            <p className="font-medium text-body-color/60">{title}</p>
            <p className="text-sm text-body-color/40">{description}</p>
        </div>
    )
}

export function EmptyWishlistState({ title = 'Your wishlist is empty', description = "Save items you love and find them here anytime." }: EmptyStateProps) {
    return (
        <div className="col-span-full flex flex-col items-center justify-center py-16 gap-3 text-center">
            <div className="w-20 h-20 p-5 rounded-full bg-muted-color flex items-center justify-center text-body-color mb-2">
                <HeartOutlineSVG />
            </div>
            <p className="text-lg font-medium">{title}</p>
            <p className="text-sm text-body-color/60 max-w-[260px] leading-relaxed">{description}</p>
            <Link
                href={getHomePath()}
                className="mt-2 inline-block border border-body-color text-body-color text-xs uppercase tracking-widest py-2.5 px-6 rounded-full hover:bg-body-color hover:text-white transition-colors"
            >
                Explore Products
            </Link>
        </div>
    )
}

export function EmptyShoppingCartState() {
    return (
        <div className="flex flex-col items-center justify-center gap-2 py-16 text-center border-t border-muted-color">
            <div className="w-20 h-20 p-5 rounded-full bg-muted-color flex items-center justify-center text-body-color mb-2">
                <BagSVG />
            </div>
            <p className="text-lg font-medium">Your cart is empty</p>
            <p className="text-sm text-body-color/60">Looks like you haven&apos;t added anything yet.</p>
            <Link
                href={getHomePath()}
                className="mt-2 inline-block border border-body-color text-body-color text-xs uppercase tracking-widest py-2.5 px-6 rounded-full hover:bg-body-color hover:text-white transition-colors"
            >
                Continue Shopping
            </Link>
        </div>
    )
}